Vue.component('specialCard', {
    template: templates.specialCard,
    props: ['card', 'show'],
    data() {
      return {
        model: {
          show: false,
          timer: null,
          cooldown: this.card.cooldown,
          isDragging: false,
          menuVisible: false,
          menuX: 0,
          menuY: 0,
          tooltipMessage: ''
        }
      }
    },
    mounted() {
      const c = this;
  
      if (c.show) {
        c.model.show = true;
      }
  
      c.$root.$on(`flip${this.card.id}`, id => {
        c.flip(id);
      });

      c.$root.$on(`say${this.card.cardNumber}`, data => {
        c.model.tooltipMessage = data.message
  
        const $card = $(`.ascension-card[data-number="${data.cards.cardNumber}"] .tooltip:visible`);

        $card.addClass('show');
  
        setTimeout(function() {
          $card.removeClass('show');
        }, 5000);
      });
  
      if (c.card.cooldown) {
        c.timer();
      }
    },
    watch: {
      show: function(newVal) {
        if (newVal) {
          this.model.show = true;
        }
      },
      card: function() {
        const c = this;
  
        c.model.timer = null;
        
        if (c.card.cooldown) {
          clearInterval(c.model.timer);
          c.timer();
        }
      }
    },
    methods: {
      timer() { 
        const c = this;
  
        let seconds = Math.round(c.card.cooldown * 60);
  
        c.model.timer = setInterval(function() {
          seconds -= 1;
  
          if (seconds > -1) {
            c.card.cooldown = c.format(seconds);
          } else {
            c.card.cooldown = null;
            clearInterval(c.model.timer);
          }
  
        }, 1000);
  
      },
      format(time) {
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;
  
        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";
        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
      },
      flip(id) {

        if (id && this.card.name && this.card.owned !== false) {
          const c = this;
          
          const $card = $(`[data-id="${id}"] .playing-card:visible`);
          //$card.addClass('playing-card--flipped');
  
          // if($card.hasClass('flipped')) {
          //   $card.addClass('unflip');
          //   setTimeout(function(){
          //     $card.removeClass('flipped').removeClass('unflip');
          //   }, 500);
          // }
          // else { 
            $card.addClass('flipped');
          // }
        }
      },
      select(card) {
        //card.selected = card.selected ? false : true;
      },
      onDragStart(event) {
        const c = this;
     
        event.dataTransfer.setData('text/plain', JSON.stringify(this.card));

        const cardData = JSON.stringify(this.card);

        const $card = $(`[data-number="${this.card.cardNumber}"]`)
        const $playingCardFront = $card.find('.playing-card-face');
  
        $playingCardFront.removeClass('playing-card-backing')
        $playingCardFront.addClass('dragging')
       
        c.model.isDragging = true;
        
    },
      onDragEnd(event) {
      const c = this;
      // console.log(event)

      const $card = $(`[data-number="${this.card.cardNumber}"]`)
      const $playingCardFront = $card.find('.playing-card-face');
  
      $playingCardFront.removeClass('dragging')


      c.model.isDragging = false;
     
    },
    showContextMenu(event) {
      const c = this;
      c.model.menuVisible = true;
      c.model.menuX = event.clientX;
      c.model.menuY = event.clientY;
    },
    closeContextMenu() {
      const c = this;
      c.model.menuVisible = false;
    },
    addFavorites() {
      const c = this;
  
      c.closeContextMenu();
      userService.addRemoveToFavorites({cardNumber: c.card.cardNumber, twitchId: utils.cookies.get('user_id'), add: true, dateCreated: c.card.dateCreated})
      .then(function (response) {
        c.$root.$emit('updateCards');
      })
  
    },
    removeFavorites() {
      const c = this;
  
      c.closeContextMenu();
      userService.addRemoveToFavorites({cardNumber: c.card.cardNumber, twitchId: utils.cookies.get('user_id'), add: false, dateCreated: c.card.dateCreated})
      .then(function (response) {
        c.$root.$emit('updateCards');
      })
  
    },
    }
  });